import { useMediaQuery, type Theme } from "@mui/material";
import DesktopSideNav from "./DesktopSideNav";
import MobileSideNav from "./MobileSideNav";

export default function SideNav() {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  return isMobile ? <MobileSideNav /> : <DesktopSideNav />;
}
